import Modal from '../Modal';
import styles from './DeleteModal.module.scss';
import Button from '../Button';
import Typography from '../Typography';

type Props = {
  openModal: boolean;
  setOpenModal: (openModal: boolean) => void;
  onDelete: () => void;
  text?: string;
  title?: string;
  component?: React.ReactNode;
  confirmText?: string;
  buttonType?: 'danger' | 'gray' | 'green';
  loading?: boolean;
};

const DeleteModal = ({
  openModal,
  setOpenModal,
  onDelete,
  text,
  title,
  component,
  confirmText,
  loading,
  buttonType = 'danger',
}: Props) => {
  return (
    <Modal
      isOpen={openModal}
      onRequestClose={() => setOpenModal(false)}
      onClose={() => setOpenModal(false)}
      className={styles.modal_wrapper}
    >
      <Typography variant="h2" style={{marginBottom: !!text ? 0 : 16}}>
        {title || 'Delete confirmation'}
      </Typography>
      {!!text && (
        <div className={styles.textWrapper}>
          <Typography className={styles.text} variant="p">
            {text}
          </Typography>
        </div>
      )}
      <div className={styles.contentWrapper}>{component}</div>
      <div className={styles.actionWrapper} style={{marginTop: 25}}>
        <Button onClick={onDelete} color={buttonType} loading={loading}>
          {confirmText || 'Delete'}
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteModal;
